/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function ExclamationIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M21.5 7.5v18c0 .875-.687 1.5-1.5 1.5-.875 0-1.5-.625-1.5-1.5v-18c0-.812.625-1.5 1.5-1.5.813 0 1.5.688 1.5 1.5M20 34c-1.125 0-2-.875-2-2 0-1.062.875-2 2-2 1.063 0 2 .938 2 2 0 1.125-.937 2-2 2"/>}
        </IconWrapper>);
}
